module.exports = __webpack_public_path__ + "media/store/images/books-7c8a0593e2726e1813bc7a998aceb8a3.png";